import { Box, Typography } from "@mui/material";
import Button from '@mui/material/Button';
import { colors } from '../../Theme/tokens';

export default function WalletNeedHelp() {

    return (
        <Box mt={2} sx={{ borderRadius: '18px', padding: '20px', display: 'flex', gap: '5px', flexDirection: 'column', textAlign: 'center' }}>
            <Typography variant='h5' sx={{ fontWeight: 500, color: colors.text.disabled, lineHeight: '25px', letterSpacing: '5%' }}>After you deposit funds into TradeTogether’s wallet’s address. You
                will have to wait 24 to 48 hours for confirmation.</Typography>
            <Button variant='text' sx={{ color: colors.primary.main, width: '100px', alignSelf: 'center', mt: 1 }}>Need Help?</Button>
        </Box>
    )
}